import { fromVector } from 'ae-cvss-calculator';

export const calculateAeBaseScore = (vector: string): number | null => {
  const cvss = fromVector(vector);
  if (!cvss?.isBaseFullyDefined()) {
    return null;
  }
  const { baseMetricsOnly, base } = cvss.calculateScores();
  return baseMetricsOnly ?? base ?? null;
};

export const calculateAeOverallScore = (vector: string): number | null => {
  const cvss = fromVector(vector);
  if (!cvss) {
    return null;
  }
  const { environmental, overall } = cvss.calculateScores();
  return environmental ?? overall ?? null;
};
